module.exports = __webpack_public_path__ + "img/13_newYouth_lt.3246bd62.png";